<div class="breadcrumb__bar" *ngIf="(breakpointService.xs$ | async) === false; else mobileBreadcrumb">
  <span class="breadcrumb__item" (click)="navigateToMainBreadcrumb.emit()" data-test="breadcrumb__title">{{ rootTitle }}</span>
  <div *ngFor="let crumb of allBreadcrumbs; let index = index">
    <span class="breadcrumb__separator"> > </span>
    <span class="breadcrumb__item" (click)="navigateToBreadcrumb.emit(index)" data-test="breadcrumb__item">
      {{ crumb.title }}
    </span>
  </div>
</div>

<ng-template #mobileBreadcrumb>
  <div class="breadcrumb__bar" *ngIf="lastBreadcrumb">
    <button (click)="navigateToSecondToLastBreadcrumb()" mat-stroked-button class="breadcrumb__back" data-test="breadcrumb__back">
      <mat-icon class="breadcrumb__back-icon">arrow_back</mat-icon>
    </button>
    <h2 class="breadcrumb__back-title text-color--primary text--light">
      {{ lastBreadcrumb.title }}
    </h2>
  </div>
</ng-template>
